// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Y_-z","fadeIn":"Z_-z","delay":"__-z","recommendedSizeTooltip":"aaa-z"};